import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, references } from '@apexdesigner/schema-tools';

export const correspondenceItem = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    subject: z.string().nullable().optional().describe('Subject line.'),

    body: z.string().nullable().optional().describe('Message body.'),

    senderId: z.number().hidden().describe('Foreign key to User'),

    recipientId: z
      .number()
      .nullable()
      .optional()
      .hidden()
      .describe('Foreign key to User'),

    sender: belongsTo('User'),

    recipient: references('User', 'recipientId'),
  })
  .describe('A correspondence record between two users.')
  .as('CorrespondenceItem');

export { correspondenceItem as correspondenceItemSchema };
